<template>
  <div class="landingPage" id="landingPage">
    <div class="search">
      <div>
        <i class="el-icon-search"></i>
        <div class="searchText" @click="goSearch">请输入产品</div>
        <el-button size="mini" style="
            background: linear-gradient(45deg, #7ace63 0%, #44c48d 100%);
            color: #fff;
            border-radius: 50px;
            padding: 0 0.2rem;
            height: 0.38rem;
            font-size: 0.16rem;
          " @click="goSearch">搜索</el-button>
      </div>
    </div>
    <!-- 主图 -->
    <div id="homeImg">
      <div class="images" @click="showModal('image1')">
        <img id="image1" src="@/assets/landingPage/home01.png" />
      </div>
      <div class="images">
        <img id="image2" src="@/assets/landingPage/home02.png" />
      </div>
      <div class="images">
        <img id="image3" src="@/assets/landingPage/home03.png" />
      </div>
      <div class="images">
        <img id="image4" src="@/assets/landingPage/home04.png" />
      </div>
      <div class="images" @click="showModal('image5')">
        <img id="image5" src="@/assets/landingPage/home05.png" />
      </div>
      <div class="images" @click="showModal('image6')">
        <img id="image6" src="@/assets/landingPage/home06.png" />
      </div>
      <div class="images" @click="showModal('image7')">
        <img id="image7" src="@/assets/landingPage/home07.png" />
      </div>
      <div class="images" @click="showModal('image8')">
        <img id="image8" src="@/assets/landingPage/home08.png" />
      </div>
      <div class="images" @click="showModal('image9')">
        <img id="image9" src="@/assets/landingPage/home09.png" />
      </div>
      <div class="images" @click="showModal('image10')">
        <img id="image10" src="@/assets/landingPage/home10.png" />
      </div>
    </div>
    <!-- 放大图 -->
    <div id="modal" style="display: none" @click="closeBtn">
      <img id="modalImage" src="" alt="大图" />
      <div id="scanCode">扫客服二维码 获取专属1v1服务</div>
    </div>
    <div class="wenda">
      <div v-for="(item, index) of QAList" :key="index"
        style="display: flex; padding: 10px 0; border-bottom: 1px solid #ccc" @click="showAll(index)">
        <div class="wenIcon">问</div>
        <div style="flex: 1; position: relative">
          <div class="question">
            <div>
              {{ item.question }}
              <img src="@/assets/landingPage/question-hot-3.png" v-if="index === 0" alt="" />
            </div>
          </div>
          <div class="answer hideAnswer" :id="`answer` + index" style="" v-html="item.answer"></div>
          <!-- <div style="position:absolute;right:0px;bottom:0px;font-size:13px;background:#fff;">...展开</div> -->
        </div>
      </div>
    </div>
    <div class="lunbo">
      <div class="lunboImg">
        <div style="display: flex; width: 100vw; position: relative; height: 27px">
          <template v-for="(item, index) of imageUrl">
            <div :key="index" class="imageUrl" :style="imageUrlIndex.indexOf(index) === -1
              ? `opacity:0;left:110px;`
              : `left:${20 * imageUrlIndex.indexOf(index)}px;`
              ">
              <img :src="item" alt="" />
            </div>
          </template>
        </div>
      </div>
      <div style="flex: 1; margin-left: 5px">获得了1v1专业解答</div>
      <div class="callPhone">
        <a :href="`tel:${phone}`" style="color: #fff">拨打电话</a>
      </div>
    </div>
    <div class="imagesQrcode" @click="showModal('image11')">
      <img id="image11" :src="customerQrcode" />
    </div>
    <div class="imageQrcodeText" style="">
      官方客服二维码
    </div>
    <!-- 预约 -->
    <div style="padding: 20px">
      <div style="text-align: center; color: #333; font-size: 23px">
        <div class="fw">即刻获取福利</div>
        <div class="fw">和专属1v1服务</div>
        <div class="yuyueLine"></div>
        <div style="font-size: 14px; color: #888">
          现在预约 专属原料顾问立即为您提供服务<br />周一至周五 9:00-22:00
          周六至周日9:00一<br />18:00
        </div>
      </div>
      <el-form :model="form" style="margin-top: 0.2rem" :rules="rules" ref="submitForm1">
        <el-row>
          <el-col :span="24">
            <el-form-item prop="name">
              <el-input placeholder="称呼" style="width: 100%" v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="phone">
              <el-input placeholder="手机" style="width: 100%" v-model="form.phone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="submitBtn" :style="bgpost > 0 && bgpost < 120 ? `transform:scale(1.06);` : ``
              " @click="submitBtn(1)">
              <div class="flash" :style="`left:calc(${bgpost}% - 40px);`"></div>
              <!-- <img src="@/assets/landingPage/light_animate.png" alt="" > -->
              立即预约
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 底部按钮 -->
    <div class="bottomBtn">
      <div>
        <i class="el-icon-phone" style="margin-right: -2px"></i>
        <a :href="`tel:${phone}`" style="color: #fff">{{ phone }}</a>
      </div>
      <div @click="showPop">
        <i class="el-icon-edit-outline" style="margin-right: -2px"></i>
        <span>免费咨询</span>
      </div>
    </div>
    <!-- 遮罩层 -->
    <div class="popup-mast" id="popup-mast" @click="hidePopup()" style="display: none"></div>
    <!-- 弹窗 -->
    <div class="popup-container">
      <div class="popup-content">
        <div class="" style="
            min-height: 50vw;
            width: 100%;
            padding-bottom: env(safe-area-inset-bottom);
          ">
          <div style="text-align: center; color: #333">
            <div>立即预约</div>
            <div>专属顾问为您提供咨询服务</div>
            <div class="yuyueLine"></div>
          </div>
          <el-form :model="form2" style="margin-top: 0.2rem" :rules="rules" ref="submitForm2">
            <el-row>
              <el-col :span="24">
                <el-form-item prop="name">
                  <el-input placeholder="称呼" style="width: 100%" v-model="form2.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item prop="phone">
                  <el-input placeholder="手机" style="width: 100%" v-model="form2.phone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <div class="submitBtn" @click="submitBtn(2)">免费咨询</div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <div id="modal2" style="display: none;" @click="closeBtn">
      <div style="background-color: #fff;width:80%;padding:20px 10px;border-radius:8px;">
        <div style="font-size:14px;text-align: center;">请完成拖动滑块验证</div>
        <verification :key="verificationkey" ref="verification1" @confirmSuccess="confirmSuccess"
          style="width: 100%; font-size: 14px; zoom: 1; margin: 20px auto 0" :id="1" type="mobile" class="switch-Tab">
        </verification>
      </div>
    </div>
    <!-- 公众号 -->
    <div class="ercodeNav" @click="showModal('image11')">
      <i class="el-icon-service"></i>
    </div>
  </div>
</template>
<script>
import { AddOnlineMessage } from "@/api/common";
import verification from '@/components/verification'
export default {
  name: "landingPage",

  components: {
    verification
  },
  data() {
    return {
      phone: "",
      show: false,
      customerQrcode: "",
      form: {
        name: "",
        phone: "",
        email: "",
        address: "",
        remark: "落地页推广留言",
        type:2,
      },
      form2: {
        name: "",
        phone: "",
        email: "",
        address: "",
        remark: "落地页推广留言",
        type:2,
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
      },
      QAList: [
        {
          question: "1.美白祛斑是即时效果，还是长效？刷酸吗？反黑吗？",
          answer: `御方汇美白祛斑原料是长效，不刷酸，不脱皮，不反黑，没有尴尬期，不借助仪器和技术即可达到美白祛斑的目标。`,
          show: false,
        },
        {
          question: "2.美白祛斑多长时间能有效果？",
          answer: `御方汇美白祛斑原料是通过重建微循环，促微循环，加快新陈代谢，同时抑制黑色素的生成来达到美白祛斑的目标，因为要重建微循环，所以需要时间，一般在使用2周时间可以看到效果，在使用3周时间可以看到显著的效果。`,
          show: false,
        },
        {
          question: "3.御方汇美白祛斑原料适用于什么类型的斑点？",
          answer: `御方汇美白祛斑原料适用于黄褐斑，妊娠斑，色素沉积斑，反黑斑，块状斑，效果显著。`,
          show: false,
        },
        {
          question: "4.原料含有激素，抗生素或违禁成分吗？",
          answer: `黄家圣幸所有的原料确保不含激素，抗生素，农药残留，重金属以及危禁成分等。均可提供第三方报告和并可随时抽检。`,
          show: false,
        },
        {
          question: "5.祛痘有刷酸吗？有用到激素，抗生素吗？",
          answer: `黄家圣幸6号祛痘原料祛痘不刷酸，不含激素，抗生素。主要通过广谱抗炎抗菌，调节面部激素水平，促微循环，修复受损肌肤来达到祛痘目标的。`,
          show: false,
        },
        {
          question: "6.黄家圣幸6号祛痘原料适用于什么类型的痘痘？",
          answer: `黄家圣幸6号祛痘原料主要适用于丘疹型，脓包型，囊肿型，玫瑰型，缔结型等痘痘及粉刺。`,
          show: false,
        },
        {
          question: "7.祛痘需要借助仪器和技术吗？",
          answer: `黄家圣幸6号祛痘原料祛痘修复只需要贴贴面膜，涂抹凝胶即可达到祛痘的目标，不借助作任何仪器和技术。`,
          show: false,
        },
        {
          question: "8.黄家圣幸7号舒缓抗敏原料适用于那些问题肌？",
          answer: `黄家圣幸7号舒缓抗敏原料适用于 敏感肌，皮肤过敏症，皮炎，湿疹，荨麻疹，以及红、肿、热、疼、痒等症状。`,
          show: false,
        },
        {
          question: "9.黄家圣幸7号舒缓抗敏原料抗敏修复需要借助仪器和技术吗？",
          answer: `黄家圣幸7号舒缓抗敏原料抗敏修复只需要贴贴面膜，涂抹凝胶或精华，即可达到舒缓、抗敏、止痒、修复的目标，不需要借助任何仪器和技术，也不含激素，抗生素等违禁成分。`,
          show: false,
        },
      ],
      imageUrl: [
        "https://fe-resource.cdn.bcebos.com/groot/mip-sjh-content-center-qa/marquee/mip-sjh-content-center-qa-avatar-68.jpeg@q_80",
        "https://fe-resource.cdn.bcebos.com/groot/mip-sjh-content-center-qa/marquee/mip-sjh-content-center-qa-avatar-69.jpeg@q_80",
        "https://fe-resource.cdn.bcebos.com/groot/mip-sjh-content-center-qa/marquee/mip-sjh-content-center-qa-avatar-70.jpeg@q_80",
        "https://fe-resource.cdn.bcebos.com/groot/mip-sjh-content-center-qa/marquee/mip-sjh-content-center-qa-avatar-71.jpeg@q_80",
        "https://fe-resource.cdn.bcebos.com/groot/mip-sjh-content-center-qa/marquee/mip-sjh-content-center-qa-avatar-72.jpeg@q_80",
        "https://fe-resource.cdn.bcebos.com/groot/mip-sjh-content-center-qa/marquee/mip-sjh-content-center-qa-avatar-73.jpeg@q_80",
        "https://fe-resource.cdn.bcebos.com/groot/mip-sjh-content-center-qa/marquee/mip-sjh-content-center-qa-avatar-74.jpeg@q_80",
        "https://fe-resource.cdn.bcebos.com/groot/mip-sjh-content-center-qa/marquee/mip-sjh-content-center-qa-avatar-75.jpeg@q_80",
        "https://fe-resource.cdn.bcebos.com/groot/mip-sjh-content-center-qa/marquee/mip-sjh-content-center-qa-avatar-76.jpeg@q_80",
      ],
      imageUrlIndex: [0, 1, 2, 3, 4],
      messageType:null,//留言类型 1为预约，2为咨询
      messageBar: {
        success: function (text) {
          var message = document.createElement("div");
          message.id = "messageBar";
          message.innerHTML = `<div style="">
                <i class="el-icon-check" style="font-size:50px;color:#fff;"></i>
             </div>
             <div style="color:#fff;font-size:16px;margin-top:10px;">${text}</div>`;
          document.getElementById("landingPage").append(message);
          setTimeout(() => {
            $("#messageBar").remove();
          }, 2000);
        },
        error: function (text) {
          var message = document.createElement("div");
          message.id = "messageBar";
          message.innerHTML = `<div style="">
                <i class="el-icon-warning-outline" style="font-size:50px;color:#fff;"></i>
             </div>
             <div style="color:#fff;font-size:16px;margin-top:10px;">${text}</div>`;
          document.getElementById("landingPage").append(message);
          setTimeout(() => {
            $("#messageBar").remove();
          }, 2500);
        },
      },
      bgpost: 0,
      verificationkey: false,
    };
  },
  mounted() {
    document.title = "广州黄家圣幸生物科技有限公司";
    this.getData();
    var that = this;
    setInterval(function () {
      var index = that.imageUrlIndex[4] + 1;
      if (index === that.imageUrl.length) {
        index = 0;
      }
      that.imageUrlIndex.splice(0, 1);
      that.imageUrlIndex.push(index);
    }, 2000);
    this.setBtnColor();
  },
  methods: {
    setBtnColor() {
      var that = this;
      if (this.bgpost < 120) {
        this.bgpost += 0.6;
        setTimeout(() => {
          that.setBtnColor();
        }, 5);
      } else {
        this.bgpost = 0;
        setTimeout(() => {
          that.setBtnColor();
        }, 1000);
      }
    },
    getData() {
      this.phone = "13922440389";
      this.customerQrcode = this.getUrlPrefix(
        this.getBaseInfo().customerQrcode
      );
    },
    showModal(id) {
      var imageUrl = document.getElementById(id).src;
      var modal = document.getElementById("modal");
      var modalImage = document.getElementById("modalImage");

      modal.style.display = "flex";
      modalImage.src = imageUrl;
      if (id === "image11") {
        modalImage.style = "max-width:60%;";
        $("#scanCode").show();
      }
    },
    closeBtn() {
      var modal = document.getElementById("modal");
      var modalImage = document.getElementById("modalImage");
      var modal2 = document.getElementById("modal2");
      this.verificationkey = !this.verificationkey
      modal.style.display = "none";
      modal2.style.display = "none";
      modalImage.src = "";
      modalImage.style = "";
      $("#scanCode").hide();
    },
    showPop() {
      // 使用JavaScript添加或移除"active"类名以触发动画效果
      var popupContainer = document.querySelector(".popup-container");
      popupContainer.classList.add("active");
      this.verificationkey = !this.verificationkey
      this.resetBtn();
      $("#popup-mast").show();
    },
    hidePopup() {
      // 使用JavaScript添加或移除"active"类名以触发动画效果
      var popupContainer = document.querySelector(".popup-container");
      popupContainer.classList.remove("active");
      this.verificationkey = !this.verificationkey
      $("#popup-mast").hide();
    },
    confirmSuccess() {
      this.messageBar.success("提交成功")
      var form
      if(this.messageType === 1){
        form = this.form
      }
      if(this.messageType === 2){
        form = this.form2
      }
      AddOnlineMessage(form)
        .then((res) => {
          this.messageBar.success("提交成功");
          var modal = document.getElementById("modal2");
            modal.style.display = "none";
          this.hidePopup();
          this.resetBtn();
        })
        .catch((res) => {
          this.messageBar.error(res);
          var modal = document.getElementById("modal2");
            modal.style.display = "none";
        });

    },
    showAll(index) {
      var answerContainer = document.querySelector("#answer" + index);
      if (this.QAList[index].show === false) {
        answerContainer.classList.remove("hideAnswer");
      }
      if (this.QAList[index].show === true) {
        answerContainer.classList.add("hideAnswer");
      }
      this.QAList[index].show = !this.QAList[index].show;
    },
    submitBtn(type) {
        this.messageType = type
      if (type === 1) {
        this.$refs["submitForm1"].validate((valid) => {
          if (valid) {
            if (this.form.email === "") {
              this.form.email = null;
            }
            var modal = document.getElementById("modal2");
            modal.style.display = "flex";
            this.verificationkey = !this.verificationkey
          }
        });
      }
      if (type === 2) {
        this.$refs["submitForm2"].validate((valid) => {
          if (valid) {
            if (this.form2.email === "") {
              this.form2.email = null;
            }
            var modal = document.getElementById("modal2");
            modal.style.display = "flex";
            this.verificationkey = !this.verificationkey
          }
        });
      }

    },
    resetBtn() {
      this.form = {
        name: "",
        phone: "",
        email: "",
        address: "",
        remark: "落地页推广留言",
        type:2,
      };
      this.form2 = {
        name: "",
        phone: "",
        email: "",
        address: "",
        remark: "落地页推广留言",
        type:2,
      };
    },
    goSearch() {
      this.$router.push({ name: "productSearch" });
    },
  },
};
</script>
<style lang="scss">
.landingPage {
  padding-bottom: calc(0.6rem + env(safe-area-inset-bottom)) !important;

  .search {
    background: #44c48d;
    padding: 10px;

    .el-input {
      .el-input__inner {
        border: 0;
        background: #fff;
      }
    }

    >div {
      display: flex;
      align-items: center;
      border: 1px solid #e5e5e5;
      background: #44c48d;
      border-radius: 50px;
      padding: 0 0.16rem;
      background: #fff;
    }
  }

  .searchText {
    font-size: 15px;
    color: #ccc;
    height: 40px;
    line-height: 40px;
    flex: 1;
    margin-left: 10px;
  }

  #messageBar {
    position: fixed;
    top: 50vh;
    left: 50vw;
    width: 36vw;
    height: 36vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transform: translateX(-50%) translateY(-50%);
    background: rgba(0, 0, 0, 0.7);
    border-radius: 10px;
    z-index: 9999999;
  }

  .fw {
    font-weight: 500;
  }

  #homeImg .images {
    width: 100vw;
  }

  #homeImg .images img {
    width: 100%;
    vertical-align: middle;
  }

  #modal2 {
    position: fixed;
    z-index: 100;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    z-index: 9999998;
    background-color: rgba(0, 0, 0, 0.7);
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  #modal {
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.7);
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  #modalImage {
    display: block;
    margin: 0 auto;
    max-width: 90%;
    max-height: 90%;
  }

  .submitBtn {
    flex: 1;
    color: #fff;
    padding: 0 16px;
    font-size: 16px;
    height: 0.5rem;
    line-height: 0.5rem;
    text-align: center;
    border-radius: 50px;
    position: relative;
    transition: 0.5s;
    background: #44c48d;
    overflow: hidden;
    position: relative;
  }

  .flash {
    width: 5px;
    position: absolute;
    top: -30%;
    box-shadow: 0px 0px 20px 20px #fff;
    background: #ffffff;
    opacity: 0.5;
    height: 140%;
    transform: rotateZ(40deg);
  }

  #scanCode {
    display: none;
    color: #fff;
    margin-top: 20px;
    font-size: 15px;
  }

  .lunbo {
    display: flex;
    align-items: center;
    margin: 10px;
    font-size: 13.65px;
    background: #f5fbf6;

    .lunboImg {
      width: 110px;
      overflow: hidden;
    }

    .callPhone {
      background: #44c48d;
      padding: 0px 10px;
      line-height: 26px;
      height: 26px;
      border-radius: 50px;
    }

    .imageUrl {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      border: 1px solid #fff;
      transition: left 0.3s ease;
      position: absolute;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
  }

  .imagesQrcode {
    width: 60%;
    margin: -5px auto 0;
    border-radius: 10px;

    img {
      border-radius: 10px;
      width: 100%;
      height: 100%;
    }
  }

  .imageQrcodeText {
    font-size: 17px;
    text-align: center;
    margin: 0px auto 10px;
  }

  .yuyueLine {
    width: 20px;
    height: 5px;
    background: #44c48d;
    margin: 10px auto;
    border-radius: 50px;
  }

  .bottomBtn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: calc(100% - 30px);
    height: 0.4rem;
    line-height: 0.4rem;
    background: #fff;
    box-shadow: 0 -1px 1px #e5e5e5;
    display: flex;
    align-items: center;
    padding: 10px 15px;
    padding-bottom: calc(env(safe-area-inset-bottom) + 10px);
    font-size: 14px;
    z-index: 50;

    >div {
      flex: 1;
      border-radius: 50px;
      background: #44c48d;
      color: #fff;
      padding: 0 16px;
      height: 0.5rem;
      line-height: 0.5rem;
      text-align: center;
    }

    >div:first-child {
      margin-right: 20px;
    }
  }

  .popup-mast {
    position: fixed;
    z-index: 100;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.7);
    align-items: center;
  }

  .popup-container {
    position: fixed;
    bottom: -100%;
    /* 初始位置在屏幕下方 */
    z-index: 101;
    left: 0;
    width: 100%;
    height: auto;
    background-color: #ffffff;
    transition: bottom 0.3s ease;
    /* 底部动画过渡效果 */
    border-radius: 10px 10px 0 0;
  }

  .popup-content {
    padding: 20px;
    border-radius: 10px;
  }

  .popup-container.active {
    bottom: 0;
    /* 弹窗出现时的位置 */
  }

  .ercodeNav {
    position: fixed;
    right: 10px;
    bottom: 1rem;
    width: 50px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    box-shadow: 0px 0px 5px #ccc;
    background: #fff;
    border-radius: 50%;
    font-size: 20px;
  }

  .wenda {
    padding: 16px;

    .wenIcon {
      background: #44c48d;
      border-radius: 5px;
      padding: 1px 3px;
      margin-right: 5px;
      margin-top: 2px;
      height: max-content;
      font-size: 12px;
      color: #fff;
    }

    .question {
      font-size: 16px;
      color: #333;
      margin-bottom: 10px;
      font-weight: bold;
      display: flex;
      align-items: center;
      line-height: 22px;

      img {
        width: 18px;
        height: 18px;
        margin-top: -4px;
      }
    }

    .answer {
      font-size: 13px;
      color: #666;
      text-indent: 2em;
    }

    .hideAnswer {
      display: -webkit-box;
      /* 兼容性 */
      -webkit-line-clamp: 2;
      /* 指定显示行数 */
      -webkit-box-orient: vertical;
      /* 文本垂直排列 */
      overflow: hidden;
      /* 多余部分隐藏 */
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/landingPage/index.vue